// @ts-nocheck
import React, { useState } from 'react';
import { sx } from '../sx';

type CloneOption = { id: string; label: string; disabled: boolean; reason: string; replaces: string[]; note?: string };

export default function CloneDriverModal({ name, options, onClone, onClose }: { name: string; options: CloneOption[]; onClone: (ids: string[]) => void; onClose: () => void }) {
  const [picked, setPicked] = useState<string[]>([]);
  const open = options.filter(o => !o.disabled);
  const toggle = (id: string) => {
    if (!open.some(o => o.id === id)) return;
    setPicked(p => (p.indexOf(id) >= 0 ? p.filter(x => x !== id) : p.concat(id)));
  };
  const replacing = options.filter(o => picked.indexOf(o.id) >= 0 && o.replaces.length);
  const confirm = () => {
    if (!picked.length) return;
    onClone(picked);
    onClose();
  };
  const onKey = e => {
    if (e.key === 'Escape') onClose();
  };

  return (
    <div onClick={onClose} onKeyDown={onKey} style={sx(`position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`)}>
      <div role="dialog" aria-label={'Clone ' + name} onClick={e => e.stopPropagation()} style={sx(`width:100%;max-width:${options.length > 1 ? 620 : 420}px;max-height:calc(100vh - 48px);display:flex;flex-direction:column;background:#fff;border-radius:16px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5);padding:20px;box-sizing:border-box`)}>
        <div style={sx(`display:flex;align-items:center;gap:10px;margin-bottom:10px`)}>
          <div style={sx(`flex:1;min-width:0;font-size:15px;font-weight:600;color:var(--ink);letter-spacing:-0.01em`)}>Clone {name}</div>
          <button className="gmHover" onClick={onClose} aria-label="Close" style={sx(`flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid #DCE4F2;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:13px;line-height:1;cursor:pointer`)} data-hover="background:#F5F8FA">×</button>
        </div>
        <p style={sx(`margin:0 0 12px;font-size:12.5px;line-height:1.5;color:var(--ink-3)`)}>
          {open.length
            ? 'Copies the formula, look on the plan, section and description to the channels you tick. Each channel keeps its own copy, so later changes stay on that channel.'
            : 'No other channel can take this driver.'}
        </p>
        <div role="group" aria-label="Clone to channels" style={sx(`flex:1;min-height:0;overflow-y:auto;display:grid;grid-template-columns:${options.length > 1 ? 'repeat(2,minmax(0,1fr))' : '1fr'};align-content:start;gap:6px`)}>
          {options.map(o => (
            <label key={o.id} style={sx(`display:flex;align-items:flex-start;gap:10px;padding:9px 12px;border:1px solid ${picked.indexOf(o.id) >= 0 ? '#0052CD' : '#DCE4F2'};border-radius:10px;background:${o.disabled ? '#F5F8FA' : '#fff'};cursor:${o.disabled ? 'not-allowed' : 'pointer'}`)}>
              <input type="checkbox" checked={picked.indexOf(o.id) >= 0} disabled={o.disabled} onChange={() => toggle(o.id)} style={sx(`margin-top:2px`)} />
              <span style={sx(`flex:1;min-width:0`)}>
                <span style={sx(`display:block;font-size:12.5px;color:${o.disabled ? 'var(--ink-4)' : 'var(--ink)'}`)}>{o.label}</span>
                {o.reason ? <span style={sx(`display:block;margin-top:2px;font-size:11px;color:var(--ink-4)`)}>{o.reason}</span> : null}
                {!o.disabled && o.note ? <span style={sx(`display:block;margin-top:2px;font-size:11px;color:#0052CD`)}>{o.note}</span> : null}
              </span>
            </label>
          ))}
        </div>
        {replacing.length ? (
          <div role="alert" style={sx(`margin-top:12px;padding:9px 12px;border-radius:10px;background:#FFF6E0;font-size:11.5px;line-height:1.5;color:#7A5A00`)}>
            {replacing.map(o => <div key={o.id}>Replaces the {o.replaces.join(', ')} on {o.label}.</div>)}
          </div>
        ) : null}
        <div style={sx(`display:flex;justify-content:flex-end;gap:8px;margin-top:18px`)}>
          <button className="gmHover" onClick={onClose} style={sx(`height:32px;padding:0 14px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`)} data-hover="background:#F5F8FA">Cancel</button>
          <button onClick={confirm} disabled={!picked.length} style={sx(`height:32px;padding:0 16px;border:none;border-radius:999px;background:${picked.length ? '#0052CD' : '#EDF1F8'};color:${picked.length ? '#fff' : '#8094B5'};font-family:inherit;font-size:12.5px;font-weight:500;cursor:${picked.length ? 'pointer' : 'not-allowed'}`)}>
            {picked.length ? 'Clone to ' + picked.length + (picked.length === 1 ? ' channel' : ' channels') : 'Choose channels'}
          </button>
        </div>
      </div>
    </div>
  );
}
